// Generated by Melange

import * as Buhta_cabinet__CashboxLayout from "../../components/organisms/Kassa/Cashbox/CashboxLayout.js";
import * as Buhta_cabinet__ErrorPage from "../ErrorPage.js";
import * as Buhta_cabinet__Kassa from "../../grpc/Kassa.js";
import * as Buhta_components__LoadingDiv from "../../../../../packages/components/src/atoms/LoadingDiv.js";
import * as Buhta_core__GrpcState from "../../../../../packages/core/lib/GrpcState.js";
import * as Curry from "melange.js/curry.js";
import * as React from "react";
import * as JsxRuntime from "react/jsx-runtime";

function make(org) {
  return function (id) {
    const func = Buhta_cabinet__Kassa.KkmManagerService.view;
    const match = Buhta_core__GrpcState.useModel((function (param) {
            return Curry._3(func, param, {
                        hd: "preferences",
                        tl: /* [] */0
                      }, id);
          }), undefined);
    const dispatch = match[1];
    const kkmObj = match[0];
    React.useEffect((function () {
            Curry._2(dispatch, undefined, undefined);
          }), [id]);
    if (typeof kkmObj === "string") {
      if (kkmObj === "Loading") {
        return JsxRuntime.jsx(Buhta_components__LoadingDiv.make, {});
      } else {
        return JsxRuntime.jsx(Buhta_cabinet__ErrorPage.make, {});
      }
    } else if (kkmObj.NAME === "Data") {
      return JsxRuntime.jsx(Buhta_cabinet__CashboxLayout.make, {
                  org: org,
                  kkm: kkmObj.VAL
                });
    } else {
      return JsxRuntime.jsx(Buhta_cabinet__ErrorPage.make, {});
    }
  };
}

function CashboxPage(Props) {
  return make(Props.org)(Props.id);
}

const make$1 = CashboxPage;

export {
  make$1 as make,
}
/* Buhta_cabinet__CashboxLayout Not a pure module */
